"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
function createRouterMiddleware(router) {
    return function () { return function (next) { return function (action) {
        if (action.type !== actions_1.TRIGGER_TRANSITION) {
            return next(action);
        }
        var to = action.to, params = action.params;
        router.stateService.go(to, params);
    }; }; };
}
exports.default = createRouterMiddleware;
//# sourceMappingURL=middleware.js.map